import React from 'react';
import DownloadsContainer from '../components/DownlaodsContainer';
import FullSpinner from '../components/FullSpinner';
import { useAuth } from '../context/auth';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import SEO from '../components/Seo';

function Downloads() {
  const { user, loaded } = useAuth();

  if (!loaded) {
    return null;
  }

  if (loaded && !user) {
    return (
      <SEO title='Downloads | Solaric'>
        <div className='container' style={{ padding: '5rem 0 8rem 0' }}>
          <Helmet>
            <title>Downloads | Solaric</title>
          </Helmet>
          <div className='no-downloads'>
            <h1 className='text-center download-title'>Downloads</h1>
            <h3>
              To view and download the contents Please <Link to='/login'>Login</Link> <br /> or,{' '}
              <Link to='/signup'>Create an Account.</Link>
            </h3>
          </div>
        </div>
      </SEO>
    );
  }

  if (loaded && user) {
    return (
      <>
        <Helmet>
          <title>Downloads | Solaric</title>
        </Helmet>
        <div className='download-container' style={{ marginBottom: '8rem' }}>
          <DownloadsContainer />
        </div>
      </>
    );
  }

  return <FullSpinner />;
}

export default Downloads;
